<app-page-header title="APIS Definitions Management" subtitle="Configure APIS requirements by country and port">
    <div actions class="flex gap-2">
        <p-button label="Add New" (click)="openAdd()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-toast />

    <p-dialog [(visible)]="displayDialog" [modal]="true" [header]="dialogHeader" [closable]="true" [style]="{ width: '500px' }">
        <app-apis-definitions-create-edit
            [mode]="dialogMode"
            [data]="dialogData"
            (cancel)="onDialogCancel()"
            (save)="onDialogSave($event)"
        ></app-apis-definitions-create-edit>
    </p-dialog>

    <p-table
        #dt
        [value]="definitions"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['countryCode', 'port', 'providerSupplier', 'createdBy', 'modifiedBy']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="countryCode" class="text-left w-[120px]">
                    <div class="flex items-center gap-2">
                        Country
                        <p-sortIcon field="countryCode"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="countryCode" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="port" class="text-left w-[120px]">
                    <div class="flex items-center gap-2">
                        Port
                        <p-sortIcon field="port"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="port" display="menu"></app-column-filter>
                    </div>
                </th>
                <th class="text-left min-w-[200px]">
                    <div class="flex items-center gap-2">Providers</div>
                </th>
                <th pSortableColumn="providerSupplier" class="text-left w-[150px]">
                    <div class="flex items-center gap-2">
                        Provider Supplier
                        <p-sortIcon field="providerSupplier"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="providerSupplier" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="createdBy" class="text-left w-[140px]">
                    <div class="flex items-center gap-2">
                        Created By
                        <p-sortIcon field="createdBy"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="createdBy" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="createdDate" class="text-left w-[160px]">
                    <div class="flex items-center gap-2">
                        Created Date
                        <p-sortIcon field="createdDate"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="modifiedBy" class="text-left w-[140px]">
                    <div class="flex items-center gap-2">
                        Modified By
                        <p-sortIcon field="modifiedBy"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="modifiedBy" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="modifiedDate" class="text-left w-[160px]">
                    <div class="flex items-center gap-2">
                        Modified Date
                        <p-sortIcon field="modifiedDate"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="active" class="text-left w-[100px]">
                    <div class="flex items-center gap-2">
                        Status
                        <p-sortIcon field="active"></p-sortIcon>
                    </div>
                </th>
                <th class="w-[90px]"></th>
            </tr>
        </ng-template>

        <ng-template #body let-row>
            <tr>
                <td>{{ row.countryCode }}</td>
                <td>{{ row.port }}</td>
                <td>
                    <span class="truncate max-w-[250px] inline-block" [title]="getProvidersDisplay(row)">
                        {{ getProvidersDisplay(row) }}
                    </span>
                </td>
                <td>{{ row.providerSupplier || '-' }}</td>
                <td>{{ row.createdBy }}</td>
                <td>{{ row.createdDate | date: 'yyyy-MM-dd HH:mm' }}</td>
                <td>{{ row.modifiedBy }}</td>
                <td>{{ row.modifiedDate | date: 'yyyy-MM-dd HH:mm' }}</td>
                <td>
                    <p-toggleswitch [(ngModel)]="row.active" (onChange)="onActiveToggle(row)"></p-toggleswitch>
                </td>
                <td class="text-right">
                    <div class="flex gap-2 justify-end">
                        <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="onEdit(row)"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
